<template>
  <div class="view">
    <Title title="クイズ"/>
    <QuizEditMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import QuizEditMain from '@/components/Quiz/EditMain'

export default {
  components: {
    Title,
    QuizEditMain
  }
}
</script>
